var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Hello World "+_vm._s(_vm.fullname)+" ")]),_vm._v(" "),_c('p',[_vm._v("little text behind the title")])])}
var staticRenderFns = []

export { render, staticRenderFns }